// src/app/core/constants/module-ids.ts
export const ModuleIds = {
  General: 1,
  Admin: 2,
  Transaction: 3,
  HRLink: 4,                          // "HR Link"
  Home: 5,
  CompanyDetails: 6,
  UserManagement: 7,
  ExistingUsers: 8,
  NewUserRequests: 9,
  DocumentManagement: 10,
  EarnWageWithdrawal: 11,
  WageWithdrawalRollovers: 12,
  TotalWages: 13,
  CIXORPayments: 14,
  WagesWithdrawalsRollovers: 15,      // "Wages – Withdrawals – Rollovers"

  EmployeeManagement : 16,            // "Employee Management"
  AbsenteeRecorder: 17,           // "Absentee Recorder"
  HRAdmin: 18,                     // "HR Admin"
  PayrollManagement: 19,          // "Payroll Management"
  HRSettings: 20,                // "HR Settings"
  PendingApprovals: 21,          // "Pending Approvals"
  EmployeeOnboardingRequests : 22, // "Employee Onboarding Requests"
  EmployeeModificationRequests: 23, // "Employee Modification Requests"
  SpecialAllowanceTypeRequests: 24, // "Special Allowance Type Requests"
  EmployeeSpecialAllowance: 25, // "Employee Special Allowance"
  PayDayQuickView: 36,                // "Pay Day Quick View"
	GeneratePayroll :26,              // "Generate Payroll"
	GeneratePaySlip: 27,              // "Generate Pay Slip"
	GenerateBankTransferDocuments: 28, // "Generate Bank Transfer Documents"
	GenerateBankTransferDocument: 29,  // "Generate Bank Transfer Document"
	BankTransferDocumentHistory: 30,   // "Bank Transfer Document History"
	PayrollHistory: 31,                 // "Payroll History"
	EPFETFReports: 32,                 // "EPF / ETF Reports"
	PAYETaxDeductionReports: 33,        // "PAYE / Tax Deduction Reports"
  SalaryCycle: 37,                   // "Salary Cycle"
  CompanyCalendar: 38,               // "Company Calendar"
  LeavePolicy: 39,                   // "Leave Policy"
  SpecialAllowanceType: 40,          // "Special Allowance Type"
  AddSpecialAllowance: 41,           // "Add Special Allowance"

  Configuration: 42,                 // "Configuration"
  Departments: 43,                   // "Departments"
  LeaveRequests: 44,                 // "Leave Requests"
  
  EmployeesSpecialDeductions: 45,   // "Employees - Special Deductions"
  SpecialDeductionTypes: 46,          // "Special Deduction Types"
  AddSpecialDeduction: 47,             // "Add Special Deduction Type"
  SpecialDeductionTypeRequests: 48,   // "Special Deduction Type Requests"
  HRSupportMessages: 49,              // "HR Support Messages"
  LatePaymentFees: 50,                  // "Late Payment Fees"
} as const;

export type ModuleKey = keyof typeof ModuleIds;
export type ModuleId  = (typeof ModuleIds)[ModuleKey];
